import React from 'react';
import './RowToolbar.css';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

interface SelectedCellInfo {
  rowIndex: number;
  content: string;
  columnId: string | number;
}

interface RowToolbarProps {
  selectedCell?: SelectedCellInfo | null;
  rangeSelectionCount?: number;
  onCellEdit?: (cellInfo: SelectedCellInfo) => void;
  onAddColumn?: () => void;
  onCopy?: () => void;
  onPaste?: () => void;
}

const RowToolbar: React.FC<RowToolbarProps> = ({ 
  selectedCell = null, 
  rangeSelectionCount = 0,
  onCellEdit, 
  onAddColumn, 
  onCopy, 
  onPaste 
}) => {
  // If no cell is selected, show default values
  const rowNumber = selectedCell ? selectedCell.rowIndex : null;
  const isEmpty = !selectedCell || selectedCell.content === '' || selectedCell.content === 'null';
  const cellContent = selectedCell?.content || '';

  const handleRowStatusClick = () => {
    if (selectedCell && onCellEdit) {
      onCellEdit(selectedCell);
    }
  };

  return (
    <div className="row-toolbar">
      <div className="row-info">
        {selectedCell ? (
          <>
            <span className="row-number">Row {rowNumber}</span>
            <span 
              className="row-status clickable"
              onClick={handleRowStatusClick}
              title="Click to edit this cell"
            >
              {isEmpty ? 'Empty' : cellContent}
            </span>
            {rangeSelectionCount > 0 && (
              <span className="range-info">
                {rangeSelectionCount} range{rangeSelectionCount > 1 ? 's' : ''} selected
              </span>
            )}
          </>
        ) : (
          <span className="row-status">Select cell</span>
        )}
      </div>
      <div className="toolbar-actions">
        <div className="toolbar-separator"></div>
        <button className="add-column-button" onClick={onAddColumn} title="Add column">
          <AddOutlinedIcon style={{ fontSize: '14px' }} />
          Add column
        </button>
      </div>
    </div>
  );
};

export default RowToolbar; 